import { useEffect, useState } from "react";
import { useSession } from "@clerk/react";
import { useNavigate } from "react-router-dom";
import { Button } from "@heroui/react";
import { doPrivatePostRequest } from "@/api/requests";
import { getCurrentDate } from "@/utils/dates";
export default function LoopSeriesPanel({ record, mode = "meetings" }) {
  const { session } = useSession();
  const navigate = useNavigate();
  const [records, setRecords] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setRecords(null); setError(false);
    if (!session || !record?._id) return;
    (async () => {
      try {
        const { data } = await doPrivatePostRequest({ st: "SERIES", sk: record._id }, "/meets/get", await session.getToken());
        if (data.Result !== "OK") throw new Error();
        if (!cancelled) setRecords(data.Records);
      } catch { if (!cancelled) setError(true); }
    })();
    return () => { cancelled = true; };
  }, [record?._id, session]);
  if (error) return <p role="alert">Could not load related meetings.</p>;
  if (!records) return <p>Loading…</p>;
  const filtered = mode === "recordings" ? records.filter(r => r.recording?.available) : records;
  const upcoming = records.find(r => !r.completed && `${r.meeting_date} ${r.start_time?.set}` > `${getCurrentDate()} ${new Date().toLocaleTimeString('en-GB', { timeZone: 'Africa/Johannesburg', hour: '2-digit', minute: '2-digit' })}`);
  if (mode === "overview") return <div className="flex flex-col gap-2 text-sm">
    <p>{records.length} meetings · {records.filter(r => r.recording?.available).length} recordings</p>
    {record.recurrence && <p>Repeats {record.recurrence.frequency} for {record.recurrence.count} occurrences. Edits apply to one meeting.</p>}
    <p>{upcoming ? `Next meeting: ${upcoming.meeting_date} at ${upcoming.start_time?.set}` : "No upcoming meeting in this loop."}</p>
  </div>;
  return <div className="flex flex-col gap-2 py-4">
    {!filtered.length && <p>No {mode} available.</p>}
    {filtered.map(r => <Button variant="outline" className="h-auto py-3 justify-start" key={r._id}
      onPress={() => navigate(`/${mode === "recordings" ? "recordings" : "loops"}?selected=${encodeURIComponent(r._id)}`)}>
      {r.title} · {r.meeting_date} · {r.start_time?.set}
    </Button>)}
  </div>;
}
